export const VERIFY_TIMEOUT_MSG =
  "Our system is overloaded due to too many users. You can try to reduce your photo's size or connect to a better internet connection or try again later...";

export const DUPLICATE_UPLOAD_TITLE = "Duplicate detected!";

export const DUPLICATE_UPLOAD_MSG =
  "You already uploaded that photo. All photos need to be unique from one another. Please upload a different one.";

export const MANY_FACE_MSG = "There is more than one face detected in the photo";
export const RESULT_DISCLAIMER_MSG = "Please note that we assure 3 to 5 perfect photos for each job.";
